import { WaveEventItem } from '@anm/api/modules/waveEvents/types';

import { ApplicationState } from '../../types';
import { selectMediumSize } from '../template/selectors';

export const selectCurrentWaveEvent = ({ waveEvents }: ApplicationState) => waveEvents.currentWaveEvent.data;
export const selectCurrentWaveEventError = ({ waveEvents }: ApplicationState) => waveEvents.currentWaveEvent.error;
export const selectCurrentWaveEventPending = ({ waveEvents }: ApplicationState) =>
  waveEvents.currentWaveEvent.isPending;

export const selectWaveEventsError = ({ waveEvents }: ApplicationState) => waveEvents.waveEventItems.error;
export const selectWaveEvents = (date?: string) => ({ waveEvents }: ApplicationState) => {
  const { dateEvents, startWeekDate } = waveEvents.waveEventItems;
  return dateEvents[date || startWeekDate];
};

export const selectWaveEventPreview = (waveEvent: WaveEventItem) => {
  const { preview: templatePreview, attachments } = waveEvent;
  if (!templatePreview && !attachments) return null;

  if (attachments) {
    const eventPreviewUrl = attachments[0];

    return {
      url: eventPreviewUrl,
      size: { width: 400, height: 300 }
    };
  }

  return selectMediumSize(templatePreview);
};

export const selectWaveEventData = (currentWeekEvents: WaveEventItem[]) => {
  const waveEventIndex = currentWeekEvents.findIndex(waveEvent => {
    const isPreview = !selectWaveEventPreview(waveEvent);
    return isPreview;
  });

  return currentWeekEvents[waveEventIndex];
};
